import moment from 'moment-timezone'
import { NOTIFICATIONS } from '@/utils/constants'

export default {
  [NOTIFICATIONS.LOADING]: state => state.loading,

  [NOTIFICATIONS.GET_VISUALIZED]: state => state.visualized,

  [NOTIFICATIONS.GET_ALL]: state => {
    const notifications = []
    if (!state.loading) {
      const bulletins = state.bulletinNotifications
        .map(o => ({ ...o, icon: 'notification', color: 'var(--bulletin-color)' }))

      const generalDocument = state.generalDocumentNotifications
        .map(o => ({ ...o, icon: 'docs', color: 'var(--docs-color)' }))

      const legalDocument = state.legalDocumentNotifications
        .map(o => ({ ...o, icon: 'legal-docs', color: 'var(--docs-color)' }))

      const paymentSlip = state.paymentSlipNotifications
        .map(o => ({ ...o, icon: 'payment', color: 'var(--financial-color)' }))

      const paymentSlipLate = state.paymentSlipLateNotifications
        .map(o => ({ ...o, icon: 'payment', color: 'var(--financial-color)' }))

      const paymentSlipAnticipation = state.paymentSlipAnticipationNotifications
        .map(o => ({ ...o, icon: 'payment', color: 'var(--financial-color)' }))

      const event = state.eventNotifications
        .map(o => ({ ...o, icon: 'calendar', color: 'var(--support-color)' }))

      notifications.push(
        ...bulletins,
        ...generalDocument,
        ...legalDocument,
        ...paymentSlip,
        ...paymentSlipLate,
        ...paymentSlipAnticipation,
        ...event
      )

      if (notifications.length > 0) {
        for (let index = notifications.length - 1; index >= 0; index--) {
          const notification = notifications[index];
          if (!state.visualized[notification.id]) continue;

          const TenDaysAgo = moment().subtract(10, 'days')
          if (moment(state.visualized[notification.id].viewedAt).isBefore(TenDaysAgo)) {
            notifications.splice(index, 1)
          } else {
            notification.visualized = true
          }
        }
      }
    }
    return notifications.sort((a, b) => a.time < b.time ? 1 : -1)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/notifications/getters.js